"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFormControl = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f4f4fb;\n  color: #646464;\n  border: 1px solid #cccccc;\n  padding: 0px 22.5px;\n  border-radius: 22.5px;\n  width: auto;\n  height: 45px;\n  margin: 0px;\n  box-sizing: border-box;\n  font-family: 'Raleway', sans-serif;\n  font-size: 14px;\n  font-weight: 300;\n  cursor: inherit;\n  display: flex;\n  align-items: center;\n\n  > svg {\n    margin: 0px 7px;\n  }\n\n  &.pui-form-control--has-dropdown {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  &.pui-form-control--disabled {\n    opacity: 0.6;\n    cursor: default;\n  }\n\n  .pui-form-control__text {\n    color: #646464;\n  }\n\n  .pui-form-control__icon {\n    color: #646464;\n    display: flex;\n    align-items: center;\n  }\n\n  .pui-form-control__content {\n    display: flex;\n    flex-grow: 1;\n  }\n\n  .pui-form-control__content--dock-left {\n    margin-left: -22.5px;\n  }\n\n  .pui-form-control__content--dock-right {\n    margin-right: -22.5px;\n  }\n\n  .pui-form-control__icon.pui-form-control__icon--dock-left {\n    margin-left: -7px;\n    margin-right: 7px;\n  }\n\n  .pui-form-control__icon.pui-form-control__icon--dock-right {\n    margin-right: -7px;\n    margin-left: 7px;\n  }\n\n  .pui-form-control__input {\n    outline: none;\n    border: none;\n    background-color: transparent;\n    color: #646464;\n    flex-grow: 1;\n\n    &:hover {\n      border-bottom-color: green;\n    }\n\n    &::placeholder {\n      color: #646464;\n      opacity: 1;\n    }\n  }\n\n  &.pui-form-control--set-color {\n    color: ", ";\n    border-color: ", "78;\n\n    :hover {\n      border-color: ", ";\n    }\n\n    & > .pui-form-control__text.pui-form-control__text--highlight {\n      color: ", ";\n    }\n\n    > .pui-form-control__icon {\n      color: ", ";\n    }\n\n    > .pui-form-control__input {\n      color: ", ";\n\n      &:hover {\n        border-bottom-color: ", ";;\n      }\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n  }\n\n  &.pui-form-control--full-width {\n    width: 100%;\n  }\n\n  &.pui-form-control--no-border {\n    border: none;\n  }\n\n  &.pui-form-control--with-margin {\n    margin: 7px 0px;\n  }\n\n  &.pui-form-control--no-padding {\n    padding: 0px;\n  }\n\n  &.pui-form-control--editable {\n    cursor: text;\n  }\n\n  &.pui-form-control--clickable {\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledFormControl = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});

exports.StyledFormControl = StyledFormControl;
var FormControl = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      color = _ref.color,
      noBorder = _ref.noBorder,
      fullWidth = _ref.fullWidth,
      withMargin = _ref.withMargin,
      noPadding = _ref.noPadding,
      clickable = _ref.clickable,
      editable = _ref.editable,
      hasDropdown = _ref.hasDropdown,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "disabled", "color", "noBorder", "fullWidth", "withMargin", "noPadding", "clickable", "editable", "hasDropdown", "children"]);

  var rootProps = _objectSpread({}, props);

  var theme = (0, _useTheme["default"])();

  if (theme.palette[color] && theme.palette[color]['500']) {
    rootProps.color = theme.palette[color]['500'];
  }

  rootProps.className = (0, _clsx["default"])(className, {
    'pui-form-control--disabled': disabled,
    'pui-form-control--full-width': fullWidth,
    'pui-form-control--no-border': noBorder,
    'pui-form-control--with-margin': withMargin,
    'pui-form-control--no-padding': noPadding,
    'pui-form-control--clickable': clickable,
    'pui-form-control--editable': editable,
    'pui-form-control--has-dropdown': hasDropdown,
    'pui-form-control--set-color': rootProps.color
  });
  return /*#__PURE__*/_react["default"].createElement(StyledFormControl, _extends({}, rootProps, {
    ref: ref
  }), children);
});
FormControl.propTypes = {
  /**
   * Input color
   */
  color: _propTypes["default"].string,

  /**
   * Is it disabled?
   */
  disabled: _propTypes["default"].bool,

  /**
   * Should display border?
   */
  noBorder: _propTypes["default"].bool,

  /**
   * Full width input
   */
  fullWidth: _propTypes["default"].bool,

  /**
   * Enable margin
   */
  withMargin: _propTypes["default"].bool,

  /**
   * Disable padding
   */
  noPadding: _propTypes["default"].bool,

  /**
   * Clickable
   */
  clickable: _propTypes["default"].bool,

  /**
   * Editable
   */
  editable: _propTypes["default"].bool,

  /**
   * Has dropdown
   */
  hasDropdown: _propTypes["default"].bool
};
FormControl.defaultProps = {
  color: 'default',
  disabled: false,
  noBorder: false,
  fullWidth: true,
  withMargin: true,
  withPadding: true,
  clickable: false,
  editable: false
};
var _default = FormControl;
exports["default"] = _default;